angular.module('unergie.main')
.filter('heating', () =>
    function (val) {
        switch (val) {
            case 'gas_heating': return 'Gaz'
            case 'electric_heating': return 'Électrique'
            case 'collective_heating': return 'Collectif'
            case 'other': return 'Autre'
            default: return 'N/A'
        }
    },
)
